module.exports = __webpack_public_path__ + "static/img/zjje.26cc2de9.svg";